import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const Blog = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    list: "list:Blog",
    create: "create:Blog",
    read: "read:Blog",
    update: "update:Blog",
    delete: "delete:Blog",
  },
};
